<template>
	<ul>
		<li class="redtickl" v-bind:key="text" v-for="text in obj">{{text}}</li>
	</ul>
</template>

<script>
export default {
	name: 'ticklist',
	props: {
		obj: Array
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	ul {
		margin-top: 2em;
		padding-left: 0px;
		font-size: 1.1em;
		list-style: none;
	}
	li {
		padding: 0.75em 0px;
	}
	li:before {
		content: "";
		display: inline-block;
		margin-right: 1em;
		padding: 1.125em;
		border: 1px solid #c1c1c1;
		border-radius: 2em;
		text-align: center;
		vertical-align: middle;
	}
</style>